module.exports = __webpack_public_path__ + "static/media/logo-cardiff-uni.b9e6caed.jpg";